import Home from "../Home";

const Jewellery = () => {
  return (
    <Home url={"https://fakestoreapi.com/products/category/jewelery"} />
  );
};

export default Jewellery;
